<div class="wrapper">
    <h1 class="globalName">{{globalName}}</h1>
    <loader *ngIf="onLogin" [message]="wording.onLogin"></loader>
    <div *ngIf="!onLogin" class="form">
        <notification *ngIf="message" type="warning">{{ message }}</notification>
        <auth-form (submitAuthFormEvent)="submitLogin($event)"></auth-form>
        <div *ngIf="afidiumConnectLinks" class="afidiumConnectLinks">
            <a target="_blank" [href]="afidiumConnectLinks.createAccountLink">{{wording.createAccount}}</a>
            <a target="_blank" [href]="afidiumConnectLinks.forgotPasswordLink">{{wording.forgotPassword}}</a>
        </div>
    </div>
</div>
